module.exports = __webpack_public_path__ + "static/media/question@x5.562b4e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/taptile/src/question@x5.png
// module id = 425
// module chunks = 0